<template>
  <header class="d-sm-flex justify-content-between align-items-center">
    <h1>{{ title }}</h1>
    <b-button variant="light" :to="{name: 'Products'}">← Volver</b-button>
  </header>
</template>

<script>
export default {
  name: 'ProductHeader',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
